import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionHistoryQueueComponent } from './action-history-queue.component';
import { ListActionHistoryQueueComponent } from './components/list-action-history-queue/list-action-history-queue.component';
import { MaterialModule } from '../shared/material.module';
import { CommonsLibModule } from 'commons-lib';
import { RouterModule } from '@angular/router';
import { MatDialogModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatTableModule } from '@angular/material';
import { SharedModule } from '../shared/shared.module';
import { FilterActionHistoryQueueComponent } from './components/filter-action-history-queue/filter-action-history-queue.component';
import { ModalCalendarComponent } from './components/modal-calendar/modal-calendar.component';
import { NzDatePickerModule, NzSelectModule } from 'ng-zorro-antd';



@NgModule({
  declarations: [
    ActionHistoryQueueComponent, 
    ListActionHistoryQueueComponent, 
    FilterActionHistoryQueueComponent, 
    ModalCalendarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    CommonsLibModule.forRoot(),
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatTableModule,
    MatDialogModule,
    NzDatePickerModule,
    NzSelectModule,
    MatProgressBarModule
  ],
  entryComponents: [ModalCalendarComponent]
})
export class ActionHistoryQueueModule { }
